import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/activeBonus/active_chest_top_banner.png'
import _imports_1 from '@/assets/themetwo/active_chest_card.png'
import _imports_2 from '@/assets/activeBonus/active_chest_button_0.png'
import _imports_3 from '@/assets/activeBonus/active_chest_button_1.png'
import _imports_4 from '@/assets/themetwo/active_chest_share_bg.png'
import _imports_5 from '@/assets/activeBonus/active_chest_rules.png'
import _imports_6 from '@/assets/activeBonus/active_chest_card_side.png'
import _imports_7 from '@/assets/themetwo/active_chest_card_title.png'
import _imports_8 from '@/assets/themetwo/active_chest_arrow.png'
import _imports_9 from '@/assets/activeBonus/active_chest_inprogress.png'
import _imports_10 from '@/assets/activeBonus/active_chest_notstarted.png'
import _imports_11 from '@/assets/themetwo/active_chest_next.png'


const _hoisted_1 = { class: "mainContainer" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = { class: "chestBoard" }
const _hoisted_6 = { class: "amountCard" }
const _hoisted_7 = { class: "buttonImg" }
const _hoisted_8 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_9 = { class: "detailsBorad" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "shareText" }
const _hoisted_12 = { class: "rewardCard" }
const _hoisted_13 = { style: {"display":"flex","justify-content":"left","align-items":"center"} }
const _hoisted_14 = { class: "inviteTextCount" }
const _hoisted_15 = { class: "inviteText" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "giftContainer" }
const _hoisted_18 = { class: "imageContainer" }
const _hoisted_19 = {
  key: 0,
  src: _imports_9,
  alt: ""
}
const _hoisted_20 = {
  key: 1,
  src: _imports_10,
  alt: ""
}
const _hoisted_21 = { class: "ratioText" }
const _hoisted_22 = {
  key: 0,
  class: "arrowImg"
}
const _hoisted_23 = {
  key: 1,
  class: "arrowImgRight"
}
const _hoisted_24 = {
  key: 2,
  class: "arrowDownImg"
}

import { computed, ref } from 'vue';
import RulePopup from './components/rulePopup.vue';
import {toZigZagWithFlagsAdvance } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import { ActiveChestData, SHARE_LIST } from '@/view/activeChest/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'activeChestView',
  props: {
    dataSet: {}
  },
  emits: ['copyValue', 'chestClaim', 'goToShare', 'goToChestUser'],
  setup(__props: any, { emit: __emit }) {

const ruleRef = ref()
const shareList = ref(SHARE_LIST)

const props = __props
const emits = __emit

const zigzagReordered = computed<any>(() => {
    return toZigZagWithFlagsAdvance(props.dataSet.rewardList, 4);
})

const showRules = () => {
    ruleRef.value.open(props.dataSet.activityIntro)
}
const copyValue = (value: any) => {
    emits('copyValue', value)
}
const chestClaim = () => {
    emits('chestClaim')
}
const goToShare = async () => {
    emits('goToShare')
}

const goToChestUser = () => {
    emits('goToChestUser')
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('activityName.active_tresure_chest')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.dataSet.flatIcon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.dataSet.flatIcon,
              alt: ""
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4)),
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, " R$ " + _toDisplayString(_ctx.dataSet.amount), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.dataSet.amount <= 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _imports_3,
                  alt: "",
                  onClick: chestClaim
                }))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          style: {"border-radius":"10px"},
          src: _imports_4,
          alt: ""
        }, null, -1)),
        _createVNode(_component_van_row, { class: "linkCard" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "19",
              style: {"display":"flex","align-items":"center"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.dataSet.copyLink), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "5",
              class: "copyButtonContainer"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "copyButton",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (copyValue(_ctx.dataSet.copyLink)))
                }, _toDisplayString(_ctx.$t('common.copy')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_row, { class: "shareBtnCard" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_col, {
                key: index,
                span: "4",
                class: "shareBtn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: item.img,
                    alt: "",
                    onClick: goToShare
                  }, null, 8, _hoisted_10),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_van_row, { class: "inviteTextCard" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "16",
              class: "textRight"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('activity.inviteAssets')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "8" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "textLeft",
                  onClick: showRules
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('activity.viewRules')) + " ", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("img", {
                    src: _imports_5,
                    alt: ""
                  }, null, -1))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "topRoller" }, [
          _createElementVNode("img", {
            src: _imports_6,
            alt: ""
          })
        ], -1)),
        _createVNode(_component_van_row, { class: "rollerTitleRow" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "16",
              class: "rollerTitle"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: _imports_7,
                  alt: ""
                }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "8",
              class: "rollerBtn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "inviteBtn",
                  onClick: goToChestUser
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.dataSet.userCount), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('common.pepole')), 1)
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"display":"flex","justify-content":"right"} }, [
                    _createElementVNode("img", {
                      src: _imports_8,
                      alt: ""
                    })
                  ], -1))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_row, { class: "cardRow" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zigzagReordered.value, (value, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "cardCol",
                style: {"width":"25%"}
              }, [
                (!value.isNullObject)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          (value.received == 1)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                            : (_openBlock(), _createElementBlock("img", _hoisted_20)),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("span", null, _toDisplayString(value.received == 1 ? value.active_users :
                                    _ctx.dataSet.userCount), 1),
                            _createTextVNode(" / " + _toDisplayString(value.active_users), 1)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "amountText",
                          style: _normalizeStyle({ color: value.received == 1 ? '#D242CD' : '', fontWeight: value.received == 1 ? '600' : '', })
                        }, [
                          _cache[6] || (_cache[6] = _createTextVNode(" R$ ")),
                          _createElementVNode("span", {
                            style: _normalizeStyle({ color: value.received == 1 ? '#D242CD' : '', fontWeight: value.received == 1 ? '600' : '', })
                          }, _toDisplayString(value.reward_for_chest), 5)
                        ], 4)
                      ]),
                      (value.side == 'left' && !value.turnDown && !value.isLast)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[7] || (_cache[7] = [
                            _createElementVNode("img", {
                              src: _imports_11,
                              alt: ""
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      (value.side == 'right' && (value.displayIndex < 3))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[8] || (_cache[8] = [
                            _createElementVNode("img", {
                              src: _imports_11,
                              alt: ""
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      (value.turnDown && !value.isLast)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[9] || (_cache[9] = [
                            _createElementVNode("img", {
                              src: _imports_11,
                              alt: ""
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "bottomRoller" }, [
          _createElementVNode("img", {
            src: _imports_6,
            alt: ""
          })
        ], -1))
      ])
    ]),
    _createVNode(RulePopup, {
      ref_key: "ruleRef",
      ref: ruleRef
    }, null, 512)
  ], 64))
}
}

})